import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import { Heading, Text } from '../../../Elements/Elements';

import classes from './Info.module.scss';

const Info = ({ data }) => {
  const { t } = useTranslation(['activity']);

  return (
    <div className={classes.statistic}>
      <div className={classes.lic}>
        <Heading className={classes.title}>
          {t('activity:customers.TOTAL_LICENSES')}
        </Heading>
        <Text type="p" className={classes.space}>
          <Text>
            <Text className={classes.text_big}>{data.licenses.current}</Text>
            <Text className={classes.text}>{` /${data.licenses.max}`}</Text>
          </Text>
          <Text className={classes.text}>{`${data.percent}%`}</Text>
        </Text>
      </div>
      <div className={classes.border}></div>
      <div className={classes.gate}>
        <Heading className={classes.title}>
          {t('activity:platform.GATEWAYS')}
        </Heading>
        <Text type="p">
          <Text className={classes.text_big}>{data.gateways.current}</Text>
          <Text className={classes.text}>{` /${data.gateways.max}`}</Text>
        </Text>
      </div>
    </div>
  );
};

Info.propTypes = {
  data: PropTypes.object
};

export default Info;
